/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ApproveDocumentRequest as BackendCoreApiModelsAppAdministrationApproveDocumentRequest } from '../models/Backend/Core/Api/Models/App/Administration/approve-document-request';
import { RemoveDocumentRequest as BackendCoreApiModelsAppAdministrationRemoveDocumentRequest } from '../models/Backend/Core/Api/Models/App/Administration/remove-document-request';
import { CommitmentDocumentResponse as BackendCoreApiModelsAppReportsCommitmentDocumentResponse } from '../models/Backend/Core/Api/Models/App/Reports/commitment-document-response';
import { OrderDocumentResponse as BackendCoreApiModelsAppReportsOrderDocumentResponse } from '../models/Backend/Core/Api/Models/App/Reports/order-document-response';
import { PharmacyDocumentResponse as BackendCoreApiModelsAppReportsPharmacyDocumentResponse } from '../models/Backend/Core/Api/Models/App/Reports/pharmacy-document-response';
import { ProductCertificateDocumentRequest as BackendCoreApiModelsAppReportsProductCertificateDocumentRequest } from '../models/Backend/Core/Api/Models/App/Reports/product-certificate-document-request';
import { ProductCertificateDocumentResponse as BackendCoreApiModelsAppReportsProductCertificateDocumentResponse } from '../models/Backend/Core/Api/Models/App/Reports/product-certificate-document-response';
import { ProductCertificateResponse as BackendCoreApiModelsAppReportsProductCertificateResponse } from '../models/Backend/Core/Api/Models/App/Reports/product-certificate-response';
import { SimpleResponse as SharedKernelModelsSimpleResponse } from '../models/SharedKernel/Models/simple-response';

@Injectable({
  providedIn: 'root',
})
export class AppAdministrationBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation approveDocument
   */
  static readonly ApproveDocumentPath = '/api/app/document/approve';

  /**
   * Approve document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approveDocument$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  approveDocument$Plain$Response(params: {
    body: BackendCoreApiModelsAppAdministrationApproveDocumentRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.ApproveDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Approve document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `approveDocument$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  approveDocument$Plain(params: {
    body: BackendCoreApiModelsAppAdministrationApproveDocumentRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.approveDocument$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Approve document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approveDocument$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  approveDocument$Json$Response(params: {
    body: BackendCoreApiModelsAppAdministrationApproveDocumentRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.ApproveDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Approve document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `approveDocument$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  approveDocument$Json(params: {
    body: BackendCoreApiModelsAppAdministrationApproveDocumentRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.approveDocument$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation getProductCertificateDocument
   */
  static readonly GetProductCertificateDocumentPath = '/api/app/document/product-certificate';

  /**
   * Get a product certificate document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductCertificateDocument$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCertificateDocument$Plain$Response(params: {
    body: BackendCoreApiModelsAppReportsProductCertificateDocumentRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsProductCertificateDocumentResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.GetProductCertificateDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsProductCertificateDocumentResponse>;
      })
    );
  }

  /**
   * Get a product certificate document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductCertificateDocument$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCertificateDocument$Plain(params: {
    body: BackendCoreApiModelsAppReportsProductCertificateDocumentRequest
  }): Observable<BackendCoreApiModelsAppReportsProductCertificateDocumentResponse> {

    return this.getProductCertificateDocument$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsProductCertificateDocumentResponse>) => r.body as BackendCoreApiModelsAppReportsProductCertificateDocumentResponse)
    );
  }

  /**
   * Get a product certificate document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductCertificateDocument$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCertificateDocument$Json$Response(params: {
    body: BackendCoreApiModelsAppReportsProductCertificateDocumentRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsProductCertificateDocumentResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.GetProductCertificateDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsProductCertificateDocumentResponse>;
      })
    );
  }

  /**
   * Get a product certificate document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductCertificateDocument$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCertificateDocument$Json(params: {
    body: BackendCoreApiModelsAppReportsProductCertificateDocumentRequest
  }): Observable<BackendCoreApiModelsAppReportsProductCertificateDocumentResponse> {

    return this.getProductCertificateDocument$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsProductCertificateDocumentResponse>) => r.body as BackendCoreApiModelsAppReportsProductCertificateDocumentResponse)
    );
  }

  /**
   * Path part for operation getCommitmentDocument
   */
  static readonly GetCommitmentDocumentPath = '/api/app/document/list-commitment';

  /**
   * List commitment document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCommitmentDocument$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommitmentDocument$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsCommitmentDocumentResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.GetCommitmentDocumentPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsCommitmentDocumentResponse>;
      })
    );
  }

  /**
   * List commitment document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCommitmentDocument$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommitmentDocument$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppReportsCommitmentDocumentResponse> {

    return this.getCommitmentDocument$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsCommitmentDocumentResponse>) => r.body as BackendCoreApiModelsAppReportsCommitmentDocumentResponse)
    );
  }

  /**
   * List commitment document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCommitmentDocument$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommitmentDocument$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsCommitmentDocumentResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.GetCommitmentDocumentPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsCommitmentDocumentResponse>;
      })
    );
  }

  /**
   * List commitment document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCommitmentDocument$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommitmentDocument$Json(params?: {
  }): Observable<BackendCoreApiModelsAppReportsCommitmentDocumentResponse> {

    return this.getCommitmentDocument$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsCommitmentDocumentResponse>) => r.body as BackendCoreApiModelsAppReportsCommitmentDocumentResponse)
    );
  }

  /**
   * Path part for operation getOrderDocument
   */
  static readonly GetOrderDocumentPath = '/api/app/document/list-order';

  /**
   * List order document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrderDocument$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrderDocument$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsOrderDocumentResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.GetOrderDocumentPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsOrderDocumentResponse>;
      })
    );
  }

  /**
   * List order document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOrderDocument$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrderDocument$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppReportsOrderDocumentResponse> {

    return this.getOrderDocument$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsOrderDocumentResponse>) => r.body as BackendCoreApiModelsAppReportsOrderDocumentResponse)
    );
  }

  /**
   * List order document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrderDocument$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrderDocument$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsOrderDocumentResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.GetOrderDocumentPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsOrderDocumentResponse>;
      })
    );
  }

  /**
   * List order document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getOrderDocument$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrderDocument$Json(params?: {
  }): Observable<BackendCoreApiModelsAppReportsOrderDocumentResponse> {

    return this.getOrderDocument$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsOrderDocumentResponse>) => r.body as BackendCoreApiModelsAppReportsOrderDocumentResponse)
    );
  }

  /**
   * Path part for operation getPharmacyDocument
   */
  static readonly GetPharmacyDocumentPath = '/api/app/document/list-pharmacy';

  /**
   * List pharmacy document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPharmacyDocument$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacyDocument$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsPharmacyDocumentResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.GetPharmacyDocumentPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsPharmacyDocumentResponse>;
      })
    );
  }

  /**
   * List pharmacy document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPharmacyDocument$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacyDocument$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppReportsPharmacyDocumentResponse> {

    return this.getPharmacyDocument$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsPharmacyDocumentResponse>) => r.body as BackendCoreApiModelsAppReportsPharmacyDocumentResponse)
    );
  }

  /**
   * List pharmacy document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPharmacyDocument$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacyDocument$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsPharmacyDocumentResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.GetPharmacyDocumentPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsPharmacyDocumentResponse>;
      })
    );
  }

  /**
   * List pharmacy document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPharmacyDocument$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPharmacyDocument$Json(params?: {
  }): Observable<BackendCoreApiModelsAppReportsPharmacyDocumentResponse> {

    return this.getPharmacyDocument$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsPharmacyDocumentResponse>) => r.body as BackendCoreApiModelsAppReportsPharmacyDocumentResponse)
    );
  }

  /**
   * Path part for operation getProductCertificates
   */
  static readonly GetProductCertificatesPath = '/api/app/document/list-product-certificate';

  /**
   * List product certificate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductCertificates$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductCertificates$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsProductCertificateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.GetProductCertificatesPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsProductCertificateResponse>;
      })
    );
  }

  /**
   * List product certificate.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductCertificates$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductCertificates$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppReportsProductCertificateResponse> {

    return this.getProductCertificates$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsProductCertificateResponse>) => r.body as BackendCoreApiModelsAppReportsProductCertificateResponse)
    );
  }

  /**
   * List product certificate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductCertificates$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductCertificates$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsProductCertificateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.GetProductCertificatesPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsProductCertificateResponse>;
      })
    );
  }

  /**
   * List product certificate.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductCertificates$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductCertificates$Json(params?: {
  }): Observable<BackendCoreApiModelsAppReportsProductCertificateResponse> {

    return this.getProductCertificates$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsProductCertificateResponse>) => r.body as BackendCoreApiModelsAppReportsProductCertificateResponse)
    );
  }

  /**
   * Path part for operation removeDocument
   */
  static readonly RemoveDocumentPath = '/api/app/document/remove';

  /**
   * Remove document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeDocument$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeDocument$Plain$Response(params: {
    body: BackendCoreApiModelsAppAdministrationRemoveDocumentRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.RemoveDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Remove document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeDocument$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeDocument$Plain(params: {
    body: BackendCoreApiModelsAppAdministrationRemoveDocumentRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.removeDocument$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Remove document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeDocument$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeDocument$Json$Response(params: {
    body: BackendCoreApiModelsAppAdministrationRemoveDocumentRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.RemoveDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Remove document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeDocument$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeDocument$Json(params: {
    body: BackendCoreApiModelsAppAdministrationRemoveDocumentRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.removeDocument$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation uploadCommitmentDocument
   */
  static readonly UploadCommitmentDocumentPath = '/api/app/document/upload-commitment';

  /**
   * Upload commitment document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadCommitmentDocument$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadCommitmentDocument$Plain$Response(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Description
 */
'Description': string;

/**
 * File
 */
'File': Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.UploadCommitmentDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Upload commitment document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadCommitmentDocument$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadCommitmentDocument$Plain(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Description
 */
'Description': string;

/**
 * File
 */
'File': Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.uploadCommitmentDocument$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Upload commitment document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadCommitmentDocument$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadCommitmentDocument$Json$Response(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Description
 */
'Description': string;

/**
 * File
 */
'File': Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.UploadCommitmentDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Upload commitment document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadCommitmentDocument$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadCommitmentDocument$Json(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Description
 */
'Description': string;

/**
 * File
 */
'File': Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.uploadCommitmentDocument$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation uploadProductCertificateDocument
   */
  static readonly UploadProductCertificateDocumentPath = '/api/app/document/upload-product-certificate';

  /**
   * Upload product certificate document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadProductCertificateDocument$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadProductCertificateDocument$Plain$Response(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Description
 */
'Description': string;

/**
 * File
 */
'File': Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.UploadProductCertificateDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Upload product certificate document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadProductCertificateDocument$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadProductCertificateDocument$Plain(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Description
 */
'Description': string;

/**
 * File
 */
'File': Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.uploadProductCertificateDocument$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Upload product certificate document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadProductCertificateDocument$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadProductCertificateDocument$Json$Response(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Description
 */
'Description': string;

/**
 * File
 */
'File': Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppAdministrationBackendService.UploadProductCertificateDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Upload product certificate document.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadProductCertificateDocument$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadProductCertificateDocument$Json(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Description
 */
'Description': string;

/**
 * File
 */
'File': Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.uploadProductCertificateDocument$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

}
